import React, { useEffect, useState } from "react";
import { VictoryChart, VictoryBar, VictoryAxis, VictoryContainer } from "victory";
import { extendedColors } from '../ReportsHelper';
import NoData from '../NoData';
import ReportChart from './ReportChart';
import { ReportChartConsts } from "../ReportTooltips";

export default function NbusByBranchOrProducerChart({ branchData, producerData }) {
    const labelColor = document.documentElement.getAttribute('data-gdstheme') === 'dark' ? "#ffffff" : "#000000";
    const [useBranch, setUseBranch] = useState(false);
    const [data, setData] = useState(producerData?.filter(d => d.Data.NewBusiness > 0));

    useEffect(() => {
        const groupData = (useBranch ? branchData : producerData) || [];
        setData(groupData.length > 10 ? groupData.slice(0, 10) : groupData.filter(x => !x.GroupingKey.startsWith("N/A")));
    }, [useBranch, branchData, producerData]);

    if (!data || data.length === 0) {
        return (<ReportChart {...ReportChartConsts('nbusByBrachOrProducer')}>
            <NoData />
        </ReportChart>);
    }

    const formattedData = data.map((d) => ({
        x: d.GroupingKey,
        y: d.Data.NewBusiness,
    }));

    const formatTickLabel = (x) => {
        let [id, name] = x.split(' - ');
        if (useBranch && id === "N/A") { id = "Unassigned" };
        if (!name) return id;
        return name.length > 10
            ? `${id}\n${name.slice(0, 8)}...`
            : `${id}\n${name}`;
    };

    return (
        <ReportChart
            title={`New Business By ${useBranch ? 'Branch' : 'Producer'}`}
            tooltipContent={ReportChartConsts('nbusByBrachOrProducer').tooltipContent}
            switchToAltView={branchData?.length > 1 ? () => setUseBranch(!useBranch) : false}
        >
            <VictoryChart domainPadding={{ x: 25 }}
                padding={{ bottom: 70, left: 50, right: 50, top: 20 }}
                containerComponent={
                    <VictoryContainer
                        responsive={true}
                        preserveAspectRatio={"none"}
                    />
                }>
                <VictoryAxis
                    crossAxis
                    style={{
                        axis: { stroke: labelColor },
                        tickLabels: {
                            fontSize: 10,
                            angle: -60,
                            padding: 25,
                            fill: labelColor,
                        },
                    }}
                    tickFormat={formatTickLabel}
                />
                <VictoryAxis
                    dependentAxis
                    style={{
                        axis: { stroke: labelColor },
                        tickLabels: {
                            fontSize: 10,
                            fill: labelColor,
                        },
                        grid: {
                            stroke: labelColor,
                            size: 5,
                        },
                    }}
                    tickFormat={(x) => Math.round(x)}
                />
                <VictoryBar
                    data={formattedData}
                    colorScale={extendedColors}
                    style={{
                        data: {
                            fill: ({ index }) => extendedColors[index % extendedColors.length],
                        },
                    }}
                />
            </VictoryChart>
        </ReportChart>
    );

}